import React from 'react';
import { Trans } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as R from 'ramda';
import moment from 'moment';

import { modalsConstants } from '../../../../modules/modals';

import {IconBtnS, Text} from '../../common';
import { DisplayFlexS } from '../../../../utils/stylesHelpers';
import { RATING_WORKFLOW_STATES } from '../../../constants/ratings';

import {
  ControlsBtns,
  ControlsBtn,
  Date,
  HistoryLogWrap,
  Item,
  Name,
  NameAuthor,
  NameText,
  RatingWrap,
  NameCompany,
} from './AdminManagmentCommentsS';
import Rating from "react-rating";
import StarImg from "../../../assets/imgs/star-without-bg.svg";
import StartWithBg from "../../../assets/imgs/star-with-bg.svg";

const { MODAL_TYPES } = modalsConstants;

const RatingItemComponent = ({
  rating,
  setModalStateFor,
}) => {
  const renderActionBtns = workflow => (
    <ControlsBtns aItems="flex-end" direction="column">
      {
        workflow === RATING_WORKFLOW_STATES.DELETED &&
        <HistoryLogWrap aItems="flex-end" direction="column">
          <Text color="primaryGray"><Trans i18nKey="adminPanel.comments.commentStates.deleted"/></Text>
          <Text color="primaryGray">{moment(rating.deletedAt).format('HH:mm, D MMM YYYY')}</Text>
        </HistoryLogWrap>
      }
      {
        workflow === RATING_WORKFLOW_STATES.POSTED && rating.postedAt &&
        <HistoryLogWrap aItems="flex-end" direction="column">
          <Text color="primaryGray"><Trans i18nKey="adminPanel.comments.commentStates.posted"/></Text>
          <Text color="primaryGray">{moment(rating.postedAt).format('HH:mm, D MMM YYYY')}</Text>
        </HistoryLogWrap>
      }
      {
        workflow !== RATING_WORKFLOW_STATES.DELETED &&
        <ControlsBtn aItems="center" justify="flex-end">
          {
            workflow !== RATING_WORKFLOW_STATES.POSTED &&
            <IconBtnS
              iconName="sticky-note"
              color="green"
              bgColorHover="shamRockAlpha"
              title={i18next.t("adminPanel.comments.controlButtons.posted")}
              onClick={() => setModalStateFor(MODAL_TYPES.POST_RATING_CONFIRMATION, { open: true, id: rating._id })}
            />
          }
          <IconBtnS
            iconName="trash-alt"
            color="red"
            bgColorHover="redAlpha"
            title={i18next.t("adminPanel.comments.controlButtons.delete")}
            onClick={() => setModalStateFor(MODAL_TYPES.DELETE_RATING_CONFIRMATION, { open: true, id: rating._id })}
          />
        </ControlsBtn>
      }
    </ControlsBtns>
  );
  const ratingCreatorComment = [RATING_WORKFLOW_STATES.POSTED, RATING_WORKFLOW_STATES.DELETED].includes(rating.workflowState)? 'primary' : 'darkerViolet';

  return (
    <Item
      workflowState={rating.workflowState}
    >
      <DisplayFlexS direction="column">
        <NameCompany size="largeText" weight="bold" color={'primary'}>{R.pathOr('-', ['company', 'name'], rating)}</NameCompany>
        <Name aItems="center" >
          <FontAwesomeIcon icon="star"/>
          <NameText color="inherit"><Trans i18nKey="adminPanel.comments.ratingsName"/></NameText>
          <NameAuthor
            color={ratingCreatorComment}
            weight="bold"
          >
            {rating.createdBy.name}
            <Text
              weight="normal"
              color={ratingCreatorComment}
            > - {rating.createdBy.email}</Text>
          </NameAuthor>
        </Name>
        <RatingWrap>
          <Rating
            readonly
            initialRating={rating.score}
            emptySymbol={<img src={StarImg} alt="rating-start"/>}
            fullSymbol={<img src={StartWithBg} alt="rating-start"/>}
          />
        </RatingWrap>
        <Date
          color="inherit"
          align="left"
        >
          {moment(rating.createdAt).format('HH:mm, D MMM YYYY')}
        </Date>
      </DisplayFlexS>

      {renderActionBtns(rating.workflowState)}

    </Item>)
};

export default RatingItemComponent;
